// CHANGE THE ENDPOINT FOR TARGET ENV
export const baseURL = process.env.NEXT_PUBLIC_APP_API_URL
  ? process.env.NEXT_PUBLIC_APP_API_URL
  : "https://my-staging.naikgaji.com";
export const assetDomain = "https://aset.naikgaji.com";

// Signup redirect to Hiredly: on or after this date, all signup links go to Hiredly
const SIGNUP_REDIRECT_TO_HIREDLY_AFTER = new Date("2026-04-15");

export const getHiredlySignupUrl = () => {
  const isStaging = (process.env.NEXT_PUBLIC_APP_API_URL || "").includes(
    "staging-my-api"
  );
  return isStaging
    ? "https://staging-my.hiredly.com/?signup=true"
    : "https://my.hiredly.com/?signup=true";
};

/** Returns '/signup' before cutoff date, or full Hiredly signup URL on/after April 1st */
export const getSignupRedirectUrl = () => {
  return new Date() >= SIGNUP_REDIRECT_TO_HIREDLY_AFTER
    ? getHiredlySignupUrl()
    : "/signup";
};

/** True if signup should redirect to external Hiredly URL */
export const isSignupRedirectToHiredly = () =>
  new Date() >= SIGNUP_REDIRECT_TO_HIREDLY_AFTER;

// Jobseeker login redirect to Hiredly (my.hiredly.com) after cutoff
export const getHiredlyLoginUrl = () => {
  const isStaging = (process.env.NEXT_PUBLIC_APP_API_URL || "").includes(
    "staging-my-api"
  );
  return isStaging
    ? "https://staging-my.hiredly.com/?login=true"
    : "https://my.hiredly.com/?login=true";
};

/** Returns '/login' before cutoff, or full Hiredly jobseeker login URL on/after cutoff */
export const getLoginRedirectUrl = () => {
  return new Date() >= SIGNUP_REDIRECT_TO_HIREDLY_AFTER
    ? getHiredlyLoginUrl()
    : "/login";
};

// Employer login redirect to Hiredly (employer.hiredly.com) after cutoff
export const getHiredlyEmployerLoginUrl = () => {
  const isStaging = (process.env.NEXT_PUBLIC_APP_API_URL || "").includes(
    "staging-my-api"
  );
  return isStaging
    ? "https://staging-employer.hiredly.com/login"
    : "https://employer.hiredly.com/login";
};

/** Returns ED login URL before cutoff, or full Hiredly employer login URL on/after cutoff */
export const getEmployerLoginRedirectUrl = () => {
  return new Date() >= SIGNUP_REDIRECT_TO_HIREDLY_AFTER
    ? getHiredlyEmployerLoginUrl()
    : `${process.env.NEXT_PUBLIC_ED_URL || ""}/login`;
};

// Employer register redirect to Hiredly: on or after April 1st, all employer register links go to Hiredly
export const getHiredlyEmployerRegisterUrl = () => {
  const isStaging = (process.env.NEXT_PUBLIC_APP_API_URL || "").includes(
    "staging-my-api"
  );
  return isStaging
    ? "https://staging-employer.hiredly.com/register"
    : "https://employer.hiredly.com/register";
};

/** Base URL for employer register (Hiredly after cutoff, else ED /register/login-info) */
export const getEmployerRegisterBaseUrl = () => {
  return new Date() >= SIGNUP_REDIRECT_TO_HIREDLY_AFTER
    ? getHiredlyEmployerRegisterUrl()
    : `${process.env.NEXT_PUBLIC_ED_URL || ""}/register/login-info`;
};

/** Full URL to redirect to employer register; optional query string (e.g. { email, ...utm }) */
export const getEmployerRegisterRedirectUrl = (queryParams = null) => {
  const base = getEmployerRegisterBaseUrl();
  if (!queryParams || Object.keys(queryParams).length === 0) return base;
  const search = new URLSearchParams(queryParams).toString();
  return `${base}${base.includes("?") ? "&" : "?"}${search}`;
};

// From local midnight 1 May 2026: hide native Apply; partner jobs open external URL without login.
const PARTNER_AND_NATIVE_SUNSET_FROM = new Date(2026, 4, 1, 0, 0, 0, 0);

/** True when NaikGaji-native job apply should be hidden in the UI (partner / scraped jobs unchanged). */
export const shouldHideNativeJobApplyButton = () =>
  new Date() >= PARTNER_AND_NATIVE_SUNSET_FROM;

/** True on/after 1 May 2026: partner (scraped) Apply opens the external URL without requiring login. Before that, legacy login check applies. */
export const isPartnerApplyWithoutLoginEnabled = () =>
  new Date() >= PARTNER_AND_NATIVE_SUNSET_FROM;
